import React from "react";
import "./maintenance-notice.css";

export default function MaintenanceNotice({ title, description }) {
  return (
    <main className="maintenance-notice">
      <section className="maintenance-notice__section">
        <div className="maintenance-notice__container">
          <h1 className="maintenance-notice__title">{title}</h1>
          <p className="maintenance-notice__description">{description}</p>
        </div>
      </section>
    </main>
  );
}
